export enum EnumTipoSegmento {
  CLIENTE = 1,
  ITEM = 2,
}
